<script module lang="ts">
	export interface BaseBlockquoteProps {
		token: Tokens.Blockquote;
		options: MarkdownOptions | undefined;
		renderers: Renderers | undefined;
		variant: TxtVariant;
		boldVariant: TxtVariant;
	}
</script>

<script lang="ts">
	import type { MarkdownOptions, Renderers } from '@magidoc/plugin-svelte-marked';
	import type { Token, Tokens } from 'marked';
	import { twMerge } from 'tailwind-merge';
	import { Txt, type TxtVariant } from '../../../../Txt';
	import { MarkdownInlineTokens } from '../../MarkdownInlineTokens';

	interface Props {
		token: Tokens.Blockquote;
		variant: TxtVariant;
		boldVariant: TxtVariant;
		class?: string | undefined;
		options: MarkdownOptions | undefined;
		renderers: Renderers | undefined;
	}

	let { options, renderers, ...props }: Props = $props();

	const getParagraphToken = (_token: Token) => {
		return _token as Tokens.Paragraph;
	};
</script>

<blockquote class="font-semibold italic">
	{#each props.token.tokens as _token}
		{#if _token.type === 'paragraph'}
			<Txt variant={props.variant} class={twMerge('mb-6', props.class)}
				>"<MarkdownInlineTokens
					tokens={getParagraphToken(_token).tokens}
					{options}
					{renderers}
					variant={props.variant}
					boldVariant={props.boldVariant}
					class={props.class}
				/>"</Txt
			>
		{/if}
	{/each}
</blockquote>
